import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { KeyValueStorage } from 'record-it-utils/dataStorage/KeyValueStorage';
import { ApiRequester } from '../classes/ApiRequester/ApiRequester';
import { StorageClearer } from '../classes/StorageClearer/StorageClearer';
import { AuthenticationContext, AuthenticationContextValue, AuthenticationData } from '../context/AuthenticationContext';
export const AppAuthenticationContextProvider: FunctionComponent<PropsWithChildren> = React.memo(props => {
  const $ = _c(9);
  const {
    children
  } = props;
  const [authenticationData, setAuthenticationData] = useState(null);
  const [initialized, setInitialized] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      KeyValueStorage.getItem("authenticationData").then(loadedAuthenticationData => {
        setAuthenticationData(loadedAuthenticationData ?? null);
        setInitialized(true);
      });
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  bb0: {
    ApiRequester.setCsrfToken(authenticationData?.csrfToken ?? null);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        setAuthenticationData: data => {
          setAuthenticationData(data);
          KeyValueStorage.setItem("authenticationData", data);
        },
        logout: () => {
          setAuthenticationData(null);
          StorageClearer.clear();
        }
      };
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    const baseContextValue = t3;
    if (authenticationData) {
      let t4;
      if ($[3] !== authenticationData) {
        t4 = {
          ...baseContextValue,
          authenticationData,
          isLoggedIn: true
        };
        $[3] = authenticationData;
        $[4] = t4;
      } else {
        t4 = $[4];
      }
      t2 = t4;
      break bb0;
    }
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        ...baseContextValue,
        authenticationData: null,
        isLoggedIn: false
      };
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t2 = t4;
  }
  const authenticationContextValue = t2;
  const t3 = initialized ? children : undefined;
  let t4;
  if ($[6] !== authenticationContextValue || $[7] !== t3) {
    t4 = <AuthenticationContext.Provider value={authenticationContextValue}>{t3}</AuthenticationContext.Provider>;
    $[6] = authenticationContextValue;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
});